export interface ServiceLogger {
  debug: (...data: unknown[]) => void;
  error: (...data: unknown[]) => void;
  info: (...data: unknown[]) => void;
  warn: (...data: unknown[]) => void;
}

let serviceLogger: ServiceLogger | undefined;

/** Host apps inject their own logger (e.g. webapp SSR logger with request id prefix). */
export const setServiceLogger = (logger: ServiceLogger): void => {
  serviceLogger = logger;
};

export const resetServiceLogger = (): void => {
  serviceLogger = undefined;
};

export const getServiceLogger = (): ServiceLogger => serviceLogger ?? console;
